import { configureStore, combineReducers } from "@reduxjs/toolkit";
import appCommonReducer from "./slices/appCommonSlice";
import commonSlice from "./commonSlice";
import profileReducer from "./slices/ProfileSlice";
import toastReducer from "./slices/ToastSlice";
import floatingDialerReducer from "./slices/FloatingDialerSlice";
import faqReducer from "./slices/FaqSlice";
import eventReducer from "./slices/EventSlice";
import contactsReducer from "./slices/ContactSlice";
import callingDeviceTokenReducer from "./slices/CallingDeviceTokenSlice";
import yeastarReducer from "./slices/YeastarSlice";
import leadsReducer from "./slices/LeadSlice";
import callHistoryReducer from "./slices/CallHistorySlice";
import callHistoryAgentReducer from "./slices/CallHistoryAgentSlice";
import callHistoryNumberReducer from "./slices/CallHistoryNumberSlice";
import dashboardDataReducer from "./slices/DashboardDataSlice";
import adminCompanyReducer from "./slices/adminCompanySlice";
import activeContactReducer from "./slices/ActiveContactSlice";
import selectedTemplateReducer from "./slices/SelectedTemplateSlice";
import referralReducer from "./slices/ReferralSlice";
import selectedContactReducer from "./slices/SelectedContactSlice";
import loggedInElsewhereReducer from "./slices/LoggedInElsewhereSlice";
import wabaChatReducer from "./slices/WabaChatSlice";
import wabaCampaignReducer from "./slices/WabaCampaignSlice";
import wabaTemplateReducer from "./slices/WabaTemplateSlice";
import tagReducer from "./slices/TagSlice";
import deviceReducer from "./slices/AllDeviceSlice";
import approvedTemplatesReducer from "./slices/ApprovedTemplatesSlice";

import activityReducer from "./slices/ActivitySlice";

import emailReducer from "./slices/EmailSlice";
import planReducer from "./slices/PlanSlice";
import couponReducer from "./slices/CouponSlice";
import billingReducer from "./slices/BillingSlice";
import notificationReducer from "./slices/NotificationSlice";
import apiLogsReducer from "./slices/ApiLogsSlice";
import userSessionsReducer from "./slices/UserSessionsSlice";
import userActivityReducer from "./slices/UserActivitySlice";
import setupGuideReducer from "./slices/SetupGuideSlice";
import dashboardStatsReducer from "./slices/DashboardStatsSlice";
import didlogicReducer from "./slices/didlogicSlice";
import didlogicAdminReducer from "./slices/didlogicAdminSlice";
import kycDocumentsReducer from "./slices/kycDocumentSlice";
import numberInventoryReducer from "./slices/numberInventorySlice";
import numberCartReducer from "./slices/numberCartSlice";
import creditsReducer from "./slices/CreditsSlice";
import powerDialerReducer from "./slices/PowerDialerSlice";

const combinedReducer = combineReducers({
  common: commonSlice,
  appCommon: appCommonReducer,
  profile: profileReducer,
  toast: toastReducer,
  floatingDialer: floatingDialerReducer,
  faq: faqReducer,
  event: eventReducer,
  contacts: contactsReducer,
  callingDeviceToken: callingDeviceTokenReducer,
  yeastar: yeastarReducer,
  leads: leadsReducer,
  callHistory: callHistoryReducer,
  callHistoryAgent: callHistoryAgentReducer,
  callHistoryNumber: callHistoryNumberReducer,
  referral: referralReducer,
  selectedContact: selectedContactReducer,
  loggedInElsewhere: loggedInElsewhereReducer,

  dashboardData: dashboardDataReducer,
  adminCompany: adminCompanyReducer,
  activeContact: activeContactReducer,
  selectedTemplate: selectedTemplateReducer,
  email: emailReducer,
  activity: activityReducer,
  wabaChat: wabaChatReducer,
  tags: tagReducer,
  wabaTemplate: wabaTemplateReducer,
  devices: deviceReducer,
  wabaCampaign: wabaCampaignReducer,
  approvedTemplates: approvedTemplatesReducer,
  plans: planReducer,
  coupons: couponReducer,
  billing: billingReducer,
  notifications: notificationReducer,
  apiLogs: apiLogsReducer,
  userSessions: userSessionsReducer,
  userActivity: userActivityReducer,
  setupGuide: setupGuideReducer,
  dashboardStats: dashboardStatsReducer,
  didlogic: didlogicReducer,
  didlogicAdmin: didlogicAdminReducer,
  kycDocuments: kycDocumentsReducer,
  numberInventory: numberInventoryReducer,
  numberCart:      numberCartReducer,
  credits:         creditsReducer,
  powerDialer:     powerDialerReducer,
});

const rootReducer = (state, action) => {
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          "yeastar/initialize/fulfilled",
          "yeastar/setYeastarSDK",
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["payload.phone", "payload.pbx", "payload.destroy"],
        // Ignore these paths in the state
        ignoredPaths: ["yeastar.phone", "yeastar.pbx", "yeastar.destroy"],
      },
    }),
});


// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;

export default store;
